<template>
  <div class="srp-loading-skeleton srp-grid-layout" dir="ltr">
    <div class="srp-loading-skeleton__side-filters srp-grid-layout__side-filters">
      <side-filters-skeleton class="srp-loading-skeleton__side-filters-skeleton" />
      <wb-skeleton class="srp-loading-skeleton__filters-button" />
    </div>

    <div class="srp-loading-skeleton__amount-and-sort srp-grid-layout__amount-and-sort">
      <div class="dcp-cars-srp__result-amount srp-loading-skeleton__result-amount"><wb-skeleton /></div>
      <div class="dcp-cars-srp__sorting-dropdown srp-loading-skeleton__sorting-dropdown"><wb-skeleton /></div>
    </div>

    <div class="srp-grid-layout__results">
      <vehicle-tile-skeleton v-for="n in 12" :key="n" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SrpLoadingSkeleton',
};
</script>

<script setup lang="ts">
import SideFiltersSkeleton from './sideFiltersSkeleton.vue';
import VehicleTileSkeleton from './vehicleTileSkeleton.vue';
</script>

<style lang="scss">
@import 'https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/6.12.0/css/globals.css';
@import '../../styles/srp-grid-layout';

.srp-loading-skeleton {
  position: relative;

  &__side-filters {
    .srp-loading-skeleton__filters-button {
      display: none;
    }

    @include breakpoint-to(mq4) {
      @include wb-content-width;

      > .srp-loading-skeleton__side-filters-skeleton {
        display: none !important;
      }

      .srp-loading-skeleton__filters-button {
        display: block;
        width: 100%;
        height: 56px;
        margin: var(--wb-spacing-s) 0 var(--wb-spacing-l);
      }
    }
  }

  &__amount-and-sort {
    display: flex;

    @include breakpoint-to(mq3) {
      flex-direction: column;
      row-gap: 10px;
      margin-bottom: var(--wb-spacing-l);

      .srp-loading-skeleton__result-amount {
        wb-skeleton {
          display: block;
          width: 140px;
          height: 28px;
        }
      }

      .srp-loading-skeleton__sorting-dropdown {
        wb-skeleton {
          display: block;
          width: 100%;
          height: 54px;
        }
      }
    }

    @include breakpoint-from(mq4) {
      .srp-loading-skeleton__result-amount {
        display: flex;

        wb-skeleton {
          width: 170px;
          height: 28px;
        }
      }

      .srp-loading-skeleton__sorting-dropdown {
        width: auto;
        min-height: 108px;
        align-items: center;

        wb-skeleton {
          width: 200px;
          height: 54px;
        }
      }
    }
  }
}
</style>
